import React, { Dispatch, SetStateAction, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import styled, { css } from 'styled-components';

import { Artifact } from '../../types.ts/story';
import { useFileUpload, FileUploadType } from '../../hooks/useFileUpload';

type Props = {
  setIsLoading: (loading: boolean) => void;
  Button?: React.ReactNode;
  width?: string;
  onClick: () => void;
  type?: FileUploadType;
  callback?: (artifacts: Artifact[]) => void;
};

const FileUpload = observer((props: Props) => {
  const { setIsLoading, type, callback, onClick } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { handleUploadFiles, acceptFormats } = useFileUpload({
    uploadType: type,
    onUploadStart: () => setIsLoading(true),
    onUploadComplete: (artifacts) => {
      if (callback && artifacts) {
        callback(artifacts);
      }
      setIsLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    },
    onUploadError: (error) => {
      console.log('Error: ', error);
      setIsLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    },
  });

  const handleClick = () => {
    onClick();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <Main width={props.width} onClick={handleClick}>
      {props.Button}

      <File
        ref={fileInputRef}
        type="file"
        title=""
        multiple
        accept={acceptFormats.join(',')}
        onChange={handleUploadFiles}
      />
    </Main>
  );
});

export default FileUpload;

const Main = styled.div<{ width?: string }>`
  position: relative;
  cursor: pointer;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

const File = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
`;
